import React, { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { Toaster } from 'react-hot-toast';
import useReduxStore from '../hooks/useReduxStore';
import EventSuccess from '../pages/event-successfully/EventSuccess';
const Layout = lazy(() => import('../layout/index'));
// Credentials
const Login = lazy(() => import('../pages/credentials/login'));
const Signup = lazy(() => import('../pages/credentials/signup'));
const VerifyOtp = lazy(() => import('../pages/credentials/verify-otp'));
const Forgot = lazy(() => import('../pages/credentials/forgot'));
const CreatePassword = lazy(() => import('../pages/credentials/create-password'));
const SocialLoginCallback = lazy(() => import('../pages/credentials/social-login/callback'));

// payment status
const PaymentSuccessfull = lazy(() => import('../pages/payment-status/payment-successfull'));
const FailedPayment = lazy(() => import('../pages/payment-status/payment-failed'));


// Dashboard
const Dashboard = lazy(() => import('../pages/dashboard/index'));
const PastEventsGallery = lazy(() => import('../pages/past-events-gallery'));
const ArtistsVenues = lazy(() => import('../pages/artists-venues'));
const VenueDetails = lazy(() => import('../pages/artists-venues/venue-details'));
const Artists = lazy(() => import('../pages/artists-venues/artists'));
const ArtistDetails = lazy(() => import('../pages/artists-venues/artist-details'));
const LatestBlog = lazy(() => import('../pages/latest-blog'));
const JoinUS = lazy(() => import('../pages/Join-us'));
const RefundPolicy = lazy(() => import('../pages/refund-policy'));

//services list
const ServicesList = lazy(() => import('../pages/services-list'));

// services details
const ServicesDetails = lazy(() => import('../pages/services-details'));

// checkout
const ServiceCheckout = lazy(() => import('../pages/checkout/service-checkout'));
const MyEventCheckout = lazy(() => import('../pages/checkout/my-event-checkout'));

// Proceed To Pay

const ProceedToPay = lazy(() => import('../pages/ProceedToPay'));

// cart list
const CartList = lazy(() => import('../pages/cart-list'));

// events 
const EventCategories = lazy(() => import('../pages/events/event-categories'));
const EventsList = lazy(() => import('../pages/events/events-list'));
const EventDetails = lazy(() => import('../pages/events/event-details'));
const EventSeats = lazy(() => import('../pages/events/event-seats'));

// user verify

const UserVerification = lazy(() => import('../pages/user-verification'));


// Chat
const Chat = lazy(() => import('../pages/chat'));

// Profile Layout
const ProfileLayout = lazy(() => import('../layout/profile-layout'));
const Profile = lazy(() => import('../pages/profile'));
const BookingManagement = lazy(() => import('../pages/booking-management'));
const Service = lazy(() => import('../pages/booking-management/service'));
const Ticket = lazy(() => import('../pages/booking-management/ticket'));
const Calendar = lazy(() => import('../pages/calendar'));
const Payment = lazy(() => import('../pages/payments'));
const MyEvents = lazy(() => import('../pages/my-events'));
const GuestManagement = lazy(() => import('../pages/guest-management'));
const ReviewRating = lazy(() => import('../pages/review-rating'));
const TicketEasy = lazy(() => import('../pages/ticket-easy'));
const TicketDetails = lazy(() => import('../pages/ticket-easy/ticketDetails'));
const Registration = lazy(() => import('../pages/registration'));
const DefaultTemplate = lazy(() => import('../pages/my-events/defaultTemplate'));
const TemPlatePreview = lazy(() => import('../pages/my-events/preview'));

// Policy 
const Policy = lazy(() => import('../pages/policy/index'));
const FAQ = lazy(() => import('../pages/faq/index'));


const Notification = lazy(() => import('../pages/notification/index'));

// ofers
const Offers = lazy(() => import('../pages/offers/index'));


const TicketView = lazy(() => import('../pages/ticket-view'));




const AllRoutes = () => {
    const { selector: user } = useReduxStore("auth")
    const exitUser = user?.client_id
    return (

        <>
            <Toaster position="top-right" reverseOrder={false} />
            <Routes>
                <Route path="/login" element={
                    <ProtectedRoute exitUser={exitUser}>
                        <Login />
                    </ProtectedRoute>
                } />
                <Route path="/signup" element={
                    <ProtectedRoute exitUser={exitUser}>
                        <Signup />
                    </ProtectedRoute>
                } />
                <Route path="/verify-otp" element={
                    <ProtectedRoute exitUser={exitUser}>
                        <VerifyOtp />
                    </ProtectedRoute>
                } />
                <Route path="/forgot-password" element={
                    <ProtectedRoute exitUser={exitUser}>
                        <Forgot />
                    </ProtectedRoute>
                } />
                <Route path="/reset-password" element={
                    <ProtectedRoute exitUser={exitUser}>
                        <CreatePassword />
                    </ProtectedRoute>
                } />
                <Route path="/create-password" element={
                    <ProtectedRoute exitUser={exitUser}>
                        <CreatePassword />
                    </ProtectedRoute>
                } />
                {/* Apple redirect lands here for both sign-in and account linking */}
                <Route path="/social-login/callback" element={<SocialLoginCallback />} />
         

                <Route path="/" element={<Layout />}>
                    <Route path="/" element={<Navigate replace to={'/dashboard'} />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="chat" element={<ProtectedRoute exitUser={exitUser} >
                        <Chat />
                    </ProtectedRoute>} />
                    <Route path="past-events" element={<PastEventsGallery />} />
                    <Route path="artists" element={<Artists />} />
                    <Route path="artists/:id" element={<ArtistDetails />} />
                    <Route path="venues" element={<ArtistsVenues key="venue" type="venue" />} />
                    <Route path="venues/:id" element={<VenueDetails />} />
                    <Route path="latest-blog" element={<LatestBlog />} />
                    <Route path="join-us" element={<JoinUS />} />
                    <Route path="services" element={<ServicesList />} />
                    <Route path="offers" element={<Offers />} />
                    <Route path="refund-policy" element={<RefundPolicy />} />
                    <Route path="policy" element={<Policy />} />
                    <Route path="faq" element={<FAQ />} />
                    <Route path="notification" element={<ProtectedRoute exitUser={exitUser} >
                        <Notification />
                    </ProtectedRoute>} />
                    <Route path="services/details" element={<ServicesDetails />} />
                    <Route path="services/details/checkout" element={
                        <ProtectedRoute exitUser={exitUser} >
                            <ServiceCheckout />
                        </ProtectedRoute>
                    } />
                    <Route path="my-events/checkout/:templateId" element={
                        <ProtectedRoute exitUser={exitUser} >
                            <MyEventCheckout />
                        </ProtectedRoute>
                    } />
                    <Route path="cart-list" element={<CartList />} />
                    <Route path="event-categories" element={<EventCategories />} />
                    <Route path="event-categories/events/list" element={<EventsList />} />
                    <Route path="event-categories/events/list/details" element={<EventDetails />} />
                    <Route path="event-categories/events/list/details/seats" element={<EventSeats />} />
                    <Route path="user-verification" element={
                        <ProtectedRoute exitUser={exitUser} >
                            <UserVerification />
                        </ProtectedRoute>
                    } />
                    <Route path="proceed-to-pay" element={<ProtectedRoute exitUser={exitUser} >
                        <ProceedToPay />
                    </ProtectedRoute>} />
                    <Route path="/payment-failed" element={<FailedPayment />} />
                    <Route path="/payment-successfull" element={<PaymentSuccessfull />} />
              <Route path="/event-booked-successfully" element={
                        <EventSuccess />
                } />
                    <Route path="profile" element={
                        <ProtectedRoute exitUser={exitUser} >
                            <ProfileLayout />
                        </ProtectedRoute>
                    }>
                        <Route index element={<Profile />} />
                        <Route path="booking-management" element={<BookingManagement />}>
                            <Route index element={<Navigate replace to="service" />} />
                            <Route path="service" element={<Service />} />
                            <Route path="ticket" element={<Ticket />} />
                        </Route>
                        <Route path='calendar' element={<Calendar />} />
                        <Route path='payments' element={<Payment />} />
                        <Route path='my-events' element={<MyEvents />} />


                        <Route path='guest-management' element={<GuestManagement />} />
                        <Route path='review-rating' element={<ReviewRating />} />
                        <Route path='ticket-easy' element={<TicketEasy />} />
                        <Route path='ticket-easy/details/:id' element={<TicketDetails />} />
                        <Route path='registration' element={<Registration />} />
                    </Route>
                    <Route path='template' element={<DefaultTemplate />} />
                    <Route path='preview/:id' element={<TemPlatePreview />} />
                    <Route path='ticket/:token' element={<TicketView />} />
                </Route>
                {/* Profile */}

                <Route path="*" element={<h1>404 - Page Not Found</h1>} />
            </Routes>
        </>
    );
};

export default AllRoutes;

